import { MessageCircle, Phone, MapPin, Clock, Heart } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WHATSAPP_LINK, PHONE_PLACEHOLDER, CITY_PLACEHOLDER } from "@/lib/contact";

export const ContactIntro = () => <>
  <p className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-emerald-400 mb-4">Contact direct</p>
  <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-none">Parlons-en.</h2>
  <p className="mt-5 text-slate-300 text-base sm:text-lg max-w-xl mx-auto">Une question, un projet, une panne ? Le plus simple reste WhatsApp — réponse rapide, devis gratuit.</p>
</>;

export const ContactActions = ({ onTip }) => (
  <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
    <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="inline-flex items-center gap-3 px-9 py-5 rounded-full bg-[#10B981] text-ink font-bold uppercase tracking-wide hover:scale-105 active:scale-95 transition-transform" style={{ boxShadow: "0 0 36px rgba(16,185,129,0.45)" }}>
      <MessageCircle size={20} />Écrire sur WhatsApp
    </a>
    <button onClick={onTip} data-testid="footer-tip-button" className="inline-flex items-center gap-3 px-9 py-5 rounded-full border border-amber-400/60 text-amber-300 font-bold uppercase tracking-wide hover:bg-amber-400/10 hover:scale-105 active:scale-95 transition-[transform,background-color]">
      <Heart size={18} className="fill-amber-300" />Soutenir Pépé
    </button>
  </div>
);

export const ContactDetails = () => (
  <div className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-slate-400">
    <span className="flex items-center gap-2" data-testid="contact-phone"><Phone size={15} className="text-emerald-400" />{PHONE_PLACEHOLDER}</span>
    <span className="flex items-center gap-2" data-testid="contact-city"><MapPin size={15} className="text-emerald-400" />{CITY_PLACEHOLDER}</span>
    <span className="flex items-center gap-2" data-testid="contact-schedule"><Clock size={15} className="text-emerald-400" />Sur Rdv 24/7</span>
  </div>
);

export const FooterSignature = () => (
  <div className="mt-20 pt-8 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-4">
    <div className="flex items-center gap-2.5"><Logo size={26} /><span className="font-display text-lg tracking-wide">PEPE <span className="text-cyan-400">AVS</span></span></div>
    <p className="font-mono-ui text-[11px] uppercase tracking-widest text-slate-500" data-testid="footer-note">Réparer, installer, créer — Rosny-sous-Bois & Paris — © {new Date().getFullYear()}</p>
  </div>
);